define("shared/utils/formatters/linkedin-post-from-dynamo", ["exports", "later/models/linkedin-post"], function (_exports, _linkedinPost) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"later/models/linkedin-post"eaimeta@70e063a35619d71f
  /**
   * Converts a raw LinkedIn dynamo post into a DynamoLinkedinPost
   *
   */
  function createLinkedinPostFromDynamo(obj, socialProfile) {
    return new _linkedinPost.default({
      socialProfile,
      id: obj.id,
      createdAtUnix: obj.created_time,
      createdTime: obj.created_time,
      url: obj.url,
      imageUrl: obj.thumbnail_url ?? obj.media_url,
      impressions: convertToNumberOrUndefined(obj.impressions),
      membersReached: convertToNumberOrUndefined(obj.members_reached),
      reactions: convertToNumberOrUndefined(obj.reactions),
      commentsPost: convertToNumberOrUndefined(obj.comments_post),
      reshares: convertToNumberOrUndefined(obj.reshares),
      views: convertToNumberOrUndefined(obj.views),
      viewers: convertToNumberOrUndefined(obj.viewers),
      timeWatched: convertMillisecondsToMinutes(obj.time_watched),
      laterPostId: obj.later_post_id,
      mediaId: obj.media_id,
      mediaType: obj.media_type,
      permalink: obj.permalink,
      shortcode: obj.shortcode,
      text: obj.text
    });
  }
  function convertToNumberOrUndefined(input) {
    return input !== undefined && input !== null ? Number(input) : undefined;
  }
  function convertMillisecondsToMinutes(input) {
    if (input === undefined || input === null) {
      return undefined;
    }
    const milliseconds = Number(input);
    if (isNaN(milliseconds)) {
      return undefined;
    }
    // Convert milliseconds to minutes and round to remove decimals
    return Math.round(milliseconds / 60000);
  }
  var _default = _exports.default = createLinkedinPostFromDynamo;
});